module.exports = __webpack_public_path__ + "static/img/head_search.e719649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head_search.png
// module id = zVFY
// module chunks = 169